import React from 'react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  title: string;
  image: string;
}
const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  name,
  title,
  image
}) => {
  return <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 flex flex-col h-full" data-id="element-610">
      <div className="mb-6" data-id="element-611">
        <svg className="h-8 w-8 text-gold" fill="currentColor" viewBox="0 0 24 24" data-id="element-612">
          <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-613" />
        </svg>
      </div>
      <p className="text-darkGray mb-6 flex-grow" data-id="element-614">{quote}</p>
      <div className="flex items-center mt-auto" data-id="element-615">
        <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-616" />
        <div data-id="element-617">
          <h4 className="font-bold text-navy" data-id="element-618">{name}</h4>
          <p className="text-sm text-darkGray" data-id="element-619">{title}</p>
        </div>
      </div>
    </div>;
};
export default TestimonialCard;